module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/logo01-832a4e5e83965ea2778ff2a38dd32f3f.png";